import { styled } from '@mui/material/styles'

export const Price = styled('span', {
  name: 'Price',
  slot: 'Root',
  skipSx: true,
})`
  font-family: 'Source Sans Pro Semibold';
`
